import { render, staticRenderFns } from "./ReturnHeaders.vue?vue&type=template&id=0acad262"
import script from "./ReturnHeaders.vue?vue&type=script&lang=js"
export * from "./ReturnHeaders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports